import { BadgeCheck, IdCard, Sparkles } from "lucide-react";

export const OPEN_SHIFTS_URL = "/request/my-open-shifts";

export const REQUEST_TYPES = ["open-shift", "call-off", "direct-offer"];

export const TYPE_CLASSNAMES: Record<string, string> = {
    "open-shift": "tw-bg-blue-50 tw-text-blue-700 tw-border-blue-200",
    "call-off": "tw-bg-orange-50 tw-text-orange-700 tw-border-orange-200",
    "direct-offer": "tw-bg-violet-50 tw-text-violet-700 tw-border-violet-200",
};

export const QUALIFICATIONS = [
    { key: "skills", icon: Sparkles },
    { key: "licenses", icon: IdCard },
    { key: "certifications", icon: BadgeCheck },
] as const;
